import React from 'react';
export function TopStrip() {
  return <div className="bg-brand text-white text-center py-2 px-4 text-sm font-bold tracking-widest uppercase font-display" data-id="element-32">
      TODO TU CAMBIO FÍSICO Y MENTAL RESUELTO
    </div>;
}